import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { TokenService } from 'src/app/auth/services/token/token.service';

export const loginGuard: CanActivateFn = async (route, state) => {
  const _token = inject(TokenService);
  const _router = inject(Router);
  const login = await _token.isValidLogin();
  if (login) {
    _router.navigate(['/pages/home']);
    return false;
  }
  return true;
};
